import { Pipe, PipeTransform } from '@angular/core';

/** Префиксы номеров для людей: R — запрос на перевозку, B — ставка, D — сделка. */
export type DocPrefix = 'R' | 'B' | 'D';

/**
 * Номер для показа людям: <префикс>-<две цифры года создания>-<id>, например R-26-84, B-26-12, D-26-5.
 * Если дата создания неизвестна — берём текущий год.
 */
export function formatDocNumber(prefix: DocPrefix, id: number | null | undefined, createdAt?: string | null): string {
  if (id == null) return '';
  const date = createdAt ? new Date(createdAt) : new Date();
  const year = isNaN(date.getTime()) ? new Date().getFullYear() : date.getFullYear();
  return `${prefix}-${String(year % 100).padStart(2, '0')}-${id}`;
}

/** Номер запроса: R-26-84. */
export function formatRequestNumber(id: number | null | undefined, createdAt?: string | null): string {
  return formatDocNumber('R', id, createdAt);
}

/** В шаблоне: {{ deal.id | docNo:'D':deal.createdAt }} */
@Pipe({ name: 'docNo', standalone: true })
export class DocNumberPipe implements PipeTransform {
  transform(id: number | null | undefined, prefix: DocPrefix, createdAt?: string | null): string {
    return formatDocNumber(prefix, id, createdAt);
  }
}
